import { Component, Input, Output, EventEmitter } from '@angular/core';

// Models
import { MenuLink } from 'careerpages-base/models';

import { Router } from '@angular/router';

/**
 *
 * @class
 * CustomerLinksMenuComponent
 *
 *
 * @description
 * Displays a links menu which adapts for mobile
 *
 */
@Component({
  templateUrl: './customer-links-menu.component.html',
  selector: 'customer-links-menu',
  styleUrls: ['./customer-links-menu.component.scss']
})
export class CustomerLinksMenuComponent {

  @Input() links: MenuLink[];
  @Input() showAsDropdown: boolean = false;
  @Input() open: boolean = false;
  @Input() themeColor: string;
  @Output() closeMenu: EventEmitter<string> = new EventEmitter();

  constructor(
    private router: Router
  ) {}
}
